import React, { useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import "../styles/Landing.css";
import Logos from '../assets/logos/Logo_updated.png';
import arrowRight from '../assets/icons/arrow-right.svg';
import arrowRightBlue from '../assets/icons/arrow-right-blue.svg';
import poweredByPeclet from '../assets/logos/powered-by-peclet.svg';
import eventureLogo from '../assets/logos/landing-page-ev-logo.svg';

export default function Landing() {
  const navigate = useNavigate();
  const exploreBtnRef = useRef();

  const handleExploreClick = () => {
    if (exploreBtnRef.current) {
      exploreBtnRef.current.classList.add('button-animate');
      setTimeout(() => {
        exploreBtnRef.current.classList.remove('button-animate');
        // Navigate after animation
        navigate('/map', { state: { shouldLocate: true } });
      }, 300);
    } else {
      navigate('/map', { state: { shouldLocate: true } });
    }
  };

  const handlePlanJourneyClick = (e) => {
    // Prevent default anchor behavior to avoid # in URL
    e.preventDefault();
    // Navigate to map view without geolocation
    navigate('/map', { state: { shouldLocate: false } });
  };

  return (
    <div className="landing-bg">
      <div className="landing-card">
        <div className="landing-logo">
          <img src={eventureLogo} alt="EVenture Map Logo"></img>
        </div>
        {/*<h1 className="landing-title">
          <span className="welcome">Welcome to</span>
          <br />
          <span className="ev-title">EVenture Map</span>
        </h1> */}
        <p className="ev-desc">
          Discover the best spots around you with ease! We're here to support sustainable travel across regional NSW, promoting electric vehicle (EV) use for residents, businesses, and tourists. Explore, enjoy, and travel greener with us.
        </p>
        <button
          className="get-started"
          ref={exploreBtnRef}
          onClick={handleExploreClick}
        >
          Explore places around me <img src={arrowRight} alt="arrow right" className="arrow" />
        </button>
        <button
          type="button"
          className="plan-journey"
          role="link"
          onClick={handlePlanJourneyClick}
        >
          Plan my next journey <img src={arrowRight} alt="arrow right" className="arrow" />
        </button>
        <div className="org-card">
          <div className="org-title">Proudly brought to you by</div>
          <img src={Logos} alt="Participating Organisations" className="org-logos" />
          <div className="powered-by-section">
            <a href="https://peclet.com.au/" target="_blank"><img src={poweredByPeclet} alt="Powered by Peclet" className="powered-by-peclet" /></a>
           
          </div>
        </div>
        
      </div>
      <div className="credits">
        <ol>
          <li>Image credit: ChargeWorks</li>
        </ol>
      </div>
    </div>
  );
}
